import { z } from 'zod';

export const FORM_SCHEMA = z
  .object({
    name: z.string().min(1, 'Reason name cannot be empty'),
    allows_sub_reasons: z.boolean(),
    sub_reasons_data: z
      .object({
        allow_multiple: z.boolean(),
        sub_reasons: z
          // .array(z.string())
          .array(z.string().min(1, 'Sub-reason cannot be empty'))
          .min(2, 'Provide minimum two sub-reasons')
      })
      .nullable()
  })
  .refine(
    ({ allows_sub_reasons, sub_reasons_data }) => {
      return allows_sub_reasons ? sub_reasons_data !== null : true;
    },
    {
      message: 'Sub-reasons data is required when sub-reasons are allowed',
      path: ['sub_reasons_data']
    }
  )
  .refine(
    ({ allows_sub_reasons, sub_reasons_data }) => {
      return !!sub_reasons_data ? allows_sub_reasons === true : true;
    },
    {
      message: 'Sub-reasons must be allowed when sub-reasons data is provided',
      path: ['allows_sub_reasons']
    }
  );

/** @type {z.infer<typeof FORM_SCHEMA>} */
export const DEFAULT_FORM_DATA = {
  name: '',
  sub_reasons_data: null,
  allows_sub_reasons: false
};
